// extracted by mini-css-extract-plugin
module.exports = {"section":"H_section__0FYu3","ef-box":"H_ef-box__N2i78"};